module.exports = __webpack_public_path__ + "static/img/13.69cb0127.png";